import React from 'react';
import Scroll from 'react-scroll';

const constants = require('../../../backend/utils/constants');
const ContactType = constants.ContactType;
const CompanyFunction = constants.CompanyFunction;

import Textinput from '../components/textinput';

class UserForm extends React.Component {

	render() {
        let { handleChange, removeUser, index, state, submitCliked, 
            isSuperUser, viewAsUser, isCompanyApproved, isSignup } = this.props;

        return (
            <div className='signup-users'>
                <div className={`signup-user ${state.deleted ? 'deleted' : ''}`}>
                    <hr />
                    <div className='field-wrap'>
                        <div className='multi-column-row'>
                            <div className='column'>
                                <h3 className='signup-user-desc'>
                                    { state.contact_type == '1' ? 'Master' : 'Additional'} User Details
                                </h3>
                            </div>
                            <div className='column signup-user-action-holder'>
                                { index > 0 || !isSignup ? (state.deleted ? 
                                    <span className='deleted-info'>removed - press update to confirm</span>
                                    :
                                    <a onClick={()=>removeUser(index)}
                                        className='signup-user-action'>remove user</a>)
                                : null }
                                { index > 0 || !isSignup ? <br/> : null}
                                { isSuperUser && isCompanyApproved ?
                                    <a onClick={()=>viewAsUser(index)}
                                        className='signup-user-action'>view as user</a>
                                : null}
                            </div>
                        </div>
                    </div>
                    <div className={`field-wrap with-tip ${!state.validation.contact_type && submitCliked ? 'error' : ''}`}>
                        <Scroll.Element name={`${index}contact_type`} />
                        <label htmlFor='contact_type' className='labelactive'>
                        User type
                        </label>
						<div className='field-tip-button' onClick={this.props.openContactTypeHelper}>?</div>
						{ index == 0 && isSignup ?
							<select name='contact_type' disabled={true}>
								<option value='1'>Master User</option>
							</select>
						: <select name='contact_type' onChange={event => handleChange(event, index)} value={state.contact_type || ''}>
                            <option value=''>-- select user type --</option>
							<option value={ContactType.MASTER_USER.value}>{ContactType.MASTER_USER.string_value}</option>
                            <option value={ContactType.TRADE_SETTLEMENT_MANAGER.value}>{ContactType.TRADE_SETTLEMENT_MANAGER.string_value}</option>
                            <option value={ContactType.ALT_TRADE_SETTLEMENT_CONTACT.value}>{ContactType.ALT_TRADE_SETTLEMENT_CONTACT.string_value}</option>
                            <option value={ContactType.CREDIT_DEPARTAMENT_CONTACT.value}>{ContactType.CREDIT_DEPARTAMENT_CONTACT.string_value}</option>
                            <option value={ContactType.ALT_CREDIT_DEPARTAMENT_CONTACT.value}>{ContactType.ALT_CREDIT_DEPARTAMENT_CONTACT.string_value}</option>
                            <option value={ContactType.TRADER.value}>{ContactType.TRADER.string_value}</option>
                            <option value={ContactType.VIEWER_ONLY.value}>{ContactType.VIEWER_ONLY.string_value}</option>
                        </select> }
                    </div>
                    <div className={`field-wrap ${!state.validation.salutation && submitCliked ? 'error' : ''}`}>
                        <label htmlFor='usersalutation' className='labelactive'>
                        Salutation
                        </label>
                        <select name='salutation' onChange={event => handleChange(event, index)} value={state.salutation || ''}>
                            <option value=''>-- select salutation --</option>
                            <option value='1'>Mr.</option>
                            <option value='2'>Mrs.</option>
                            <option value='3'>Miss.</option>
                            <option value='4'>Ms.</option>
                            <option value='5'>Dr.</option>
                        </select>
                    </div>

                    <Textinput
                        label='Full name'
                        name='name'
                        scrollName={`${index}name`}
                        value={ state.name || '' }
                        onChange={ event => handleChange(event, index) }
                        required={true}
                        invalid={!state.validation.name && submitCliked}
                        type='text' />
                    <Textinput
                        label='Company title'
                        name='title'
                        scrollName={`${index}title`}
                        value={ state.title || ''}
                        onChange={ event => handleChange(event, index) }
                        required={true}
                        invalid={!state.validation.title && submitCliked}
                        type='text' />


                    <div className={`field-wrap ${!state.validation['function'] && submitCliked ? 'error' : ''}`}>
                        <Scroll.Element name={`${index}function`} />
                        <label htmlFor='userfunction' className='labelactive'>
                            Function in company
                        </label>
                        <select name='function' onChange={event => handleChange(event, index)} value={state['function'] || ''}>
                            <option value=''>-- select function in company --</option>
                            <option value={CompanyFunction.EXECUTIVE_MANAGEMENT.value}>{CompanyFunction.EXECUTIVE_MANAGEMENT.string_value}</option>
                            <option value={CompanyFunction.OWNER.value}>{CompanyFunction.OWNER.string_value}</option>
                            <option value={CompanyFunction.SALES_AND_MARKETING.value}>{CompanyFunction.SALES_AND_MARKETING.string_value}</option>
                            <option value={CompanyFunction.PROCUREMENT.value}>{CompanyFunction.PROCUREMENT.string_value}</option>
                            <option value={CompanyFunction.PRODUCTION.value}>{CompanyFunction.PRODUCTION.string_value}</option>
                            <option value={CompanyFunction.BROKER.value}>{CompanyFunction.BROKER.string_value}</option>
                            <option value={CompanyFunction.INFORMATION_TECHNOLOGY.value}>{CompanyFunction.INFORMATION_TECHNOLOGY.string_value}</option>
                            <option value={CompanyFunction.RESEARCH_AND_DEVELOPMENT.value}>{CompanyFunction.RESEARCH_AND_DEVELOPMENT.string_value}</option>
                            <option value={CompanyFunction.CONSULTANT.value}>{CompanyFunction.CONSULTANT.string_value}</option>
                            <option value={CompanyFunction.OTHER.value}>{CompanyFunction.OTHER.string_value}</option>
                        </select>
                    </div>

                    <Textinput
                        label='Email'
                        name='email'
                        scrollName={`${index}email`}
                        value={ state.email || '' }
                        onChange={ event => handleChange(event, index) }
                        required={true}
                        invalid={!state.validation.email && submitCliked}
                        type='email' />

                    { state.emailAvailability ?
                        <div className='field-note'>{ state.emailAvailability }</div>
                    : null }

                    <Textinput
                        label='Skype'
                        name='skype'
                        value={ state.skype }
                        onChange={ event => handleChange(event, index) }
                        type='text' />

                    <Textinput
                        label='Whatsapp'
                        name='whatsapp'
                        value={ state.whatsapp }
                        onChange={ event => handleChange(event, index) }
                        type='text' />

                </div>
            </div>
        )
    }
}

export default UserForm;



// WEBPACK FOOTER //
// ./source/components/userForm.js